var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingsSection',{attrs:{"title":_vm.t( 'mail', 'Mail app'),"description":_vm.t( 'mail', 'The mail app allows users to read mails on their IMAP accounts.')}},[_c('p',[_vm._v("\n\t\t"+_vm._s(_vm.t(
				'mail',
				'Here you can find instance-wide settings. User specific settings are found in the app itself (bottom-left corner).'
			))+"\n\t")]),_vm._v(" "),_c('div',{staticClass:"app-description"},[_c('h3',[_vm._v("\n\t\t\t"+_vm._s(_vm.t(
					'mail',
					'Account provisioning'
				))+"\n\t\t")]),_vm._v(" "),_c('article',[_c('p',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'A provisioning configuration will provision all accounts with a matching email address.'
					))+"\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'Using the wildcard (*) in the provisioning domain field will create a configuration that applies to all users, provided they do not match another configuration.'
					))+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'The provisioning mechanism will prioritise specific domain configurations over the wildcard domain configuration.'
					))+"\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'Should a new matching configuration be found after the user was already provisioned with another configuration, the new configuration will take precedence and the user will be reprovisioned with the configuration.'
					))+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'There can only be one configuration per domain and only one wildcard domain configuration.'
					))+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'These settings can be used in conjunction with each other.'
					))+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'If you only want to provision one domain for all users, use the wildcard (*).'
					))+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'This setting only makes most sense if you use the same user back-end for your Nextcloud and mail server of your organization.'
					))+"\n\t\t\t")])])]),_vm._v(" "),_c('h3',[_vm._v("\n\t\t"+_vm._s(_vm.t(
				'mail',
				'Provisioning Configurations'
			))+"\n\t")]),_vm._v(" "),_c('p',[_c('button',{staticClass:"config-button icon-add",on:{"click":function($event){_vm.addNew=true}}},[_vm._v("\n\t\t\t"+_vm._s(_vm.t('mail', 'Add new config'))+"\n\t\t")]),_vm._v(" "),_c('button',{staticClass:"config-button icon-settings",on:{"click":_vm.provisionAll}},[_vm._v("\n\t\t\t"+_vm._s(_vm.t('mail', 'Provision all accounts'))+"\n\t\t")]),_vm._v(" "),(_vm.addNew)?_c('ProvisioningSettings',{key:_vm.formKey,attrs:{"setting":_vm.preview,"submit":_vm.saveNewSettings,"delete-button":false}}):_vm._e(),_vm._v(" "),_vm._l((_vm.configs),function(setting){return _c('ProvisioningSettings',{key:setting.id,attrs:{"id":setting.id,"setting":setting,"submit":_vm.saveSettings,"disable":_vm.deleteProvisioning}})})],2),_vm._v(" "),_c('div',{staticClass:"app-description"},[_c('h3',[_vm._v("\n\t\t\t"+_vm._s(_vm.t(
					'mail',
					'Anti Spam Service'
				))+"\n\t\t")]),_vm._v(" "),_c('article',[_c('p',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'You can set up an anti spam service email address here.'
					))+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.t(
						'mail',
						'Any email that is marked as spam will be sent to the anti spam service.'
					))+"\n\t\t\t")])]),_vm._v(" "),_c('AntiSpamSettings')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }